import React from "react";

function Exchange() {
    return (
        <section className="exchange section-padding remove-bottom-padding">
            <div className="w-layout-blockcontainer container w-container">
                <div data-w-id="cf22f555-1edf-8b9a-15f4-63469b1838c4"
                     className="content-wrapper exchange">
                    <div className="section-title center">
                        <p className="label">Monitoring Dams</p>
                        <div className="title center">
                            <h2 className="heading-2 text-align-center">Real-Time Dam Cloud Monitoring</h2>
                            <p className="section-subtitle center">
                                Experience the future of the dam cloud monitoring with secure and transparent and decentralized solutions
                            </p>
                        </div>
                    </div>
                    <div className="echange-content-wrapper position-relative">
                        <div className="exchange-left-content">
                            <p className="body-text-14 text-align-center width">
                                Use our built-in automated notification system to monitor critical states
                            </p>
                            <img
                                src="https://cdn.prod.website-files.com/66dd49508eee94442464a25c/66e00ed7a28900d9e2c909e9_Vector%20266.svg"
                                loading="lazy" alt="" className="vector"/>
                        </div>
                        <div className="exchange-right-content">
                            <p className="body-text-14 text-align-center width">
                                Effortlessly convert data to visual graphs
                            </p>
                            <img
                                src="https://cdn.prod.website-files.com/66dd49508eee94442464a25c/66e00ee6b400163fc0d9b227_Vector%20265.svg"
                                loading="lazy" alt="" className="vector-2"/>
                        </div>
                        <img
                            src="https://cdn.prod.website-files.com/66dd49508eee94442464a25c/66e00db1430d33622e7cdfda_install-list-content-frame%20(1).png"
                            loading="lazy"
                            sizes="(max-width: 479px) 92vw, (max-width: 767px) 94vw, (max-width: 991px) 56vw, 100vw"
                            srcSet="https://cdn.prod.website-files.com/66dd49508eee94442464a25c/66e00db1430d33622e7cdfda_install-list-content-frame%20(1)-p-500.png 500w, https://cdn.prod.website-files.com/66dd49508eee94442464a25c/66e00db1430d33622e7cdfda_install-list-content-frame%20(1)-p-800.png 800w, https://cdn.prod.website-files.com/66dd49508eee94442464a25c/66e00db1430d33622e7cdfda_install-list-content-frame%20(1).png 1430w"
                            alt="" className="exchange-image"/>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Exchange;